import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ensureCarsLoaded } from '../services/carsLoader';
import { store } from '../app/store';

/** Load cars when a shopper route mounts (deferred from App bootstrap). */
export function useEnsureCars() {
  const dispatch = useDispatch();
  const cars = useSelector((state) => state.cars.items);
  const loading = useSelector((state) => state.cars.loading);

  useEffect(() => {
    if (cars.length > 0) return;
    ensureCarsLoaded(dispatch, store.getState).catch(() => {});
  }, [dispatch, cars.length]);

  return { cars, loading: loading && cars.length === 0 };
}
